import React, { Suspense, useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { RouterProvider } from 'react-router5';
import bugsnagReact from '@bugsnag/plugin-react';
import map from 'lodash/map';
import { BugsnagClient } from '@vmos2/core';
import { analyticsService } from '@vmos2/analytics';
import { SettingsProvider } from '@vmos2/providers';
import { PredefinedVersions, useBrandsThemes, useHideSplashScreen } from '@vmos2/utils';
import { router } from './router';
import App from './App';

// eslint-disable-next-line react/prop-types
export const Root = ({ bootstrapPromise }) => {
  const [bootstrap, setBootstrap] = useState(false);
  const [routerReady, setRouterReady] = useState(false);
  const { fetchBrandsThemes } = useBrandsThemes();

  useEffect(() => {
    (async () => {
      let brandThemes = [];
      const bootstrap = await bootstrapPromise;
      if (bootstrap?.hostBrands?.length) brandThemes = await fetchBrandsThemes(map(bootstrap.hostBrands, 'uuid'));
      setBootstrap({ ...bootstrap, brandThemes });
      analyticsService.init(bootstrap);
      router.setDependencies({ bootstrap });
      router.start(() => {
        setRouterReady(true);
      });
    })();
    return () => router.stop();
  }, []);
  useEffect(() => {
    BugsnagClient.use(bugsnagReact, React);
  }, []);

  useHideSplashScreen(routerReady);

  const BugsnagErrorBoundary = BugsnagClient.getPlugin('react');
  if (!routerReady || !bootstrap) return null;
  return (
    <BugsnagErrorBoundary>
      <ErrorBoundary FallbackComponent={({ error }) => error || 'There was an error...'}>
        <Suspense fallback="loading...">
          <RouterProvider router={router}>
            <SettingsProvider tenantSettings={bootstrap.settings}>
              <App bootstrap={bootstrap} />
              <PredefinedVersions />
            </SettingsProvider>
          </RouterProvider>
        </Suspense>
      </ErrorBoundary>
    </BugsnagErrorBoundary>
  );
};
